import { mdiSchool } from "@mdi/js"
import Botao from "./Botao"
import React from "react"
import { ModalTutorialYT } from "./ModalTutorialYT"
import { tutoriais } from "@tera/shared/src/tutoriais/constants"
import { useQuery, useQueryClient } from "react-query"

type Props = {
    id: string,
}

export const Tutorial = ({ id }: Props) => {
    const [showTutorial, setShowTutorial] = React.useState(false)
    const queryClient = useQueryClient()

    const qVisualizados = useQuery({
        queryKey: ['tutoriais-visualizados'],
        queryFn: async () => {
            const response = await fetch('/api/me/tutoriais')
            return response.json()
        },
    })

    const tutorial = tutoriais[id]
    if (!tutorial) return null

    const visualizado = !!(qVisualizados.data?.result as string[] | undefined)?.includes(id)

    const concluir = () => {
        setShowTutorial(false)
        if (visualizado) return

        fetch(`/api/me/tutoriais/${id}`, { method: 'POST' })
            .then(() => queryClient.invalidateQueries(['tutoriais-visualizados']))
            .catch(() => { })
    }

    return (
        <>
            <ModalTutorialYT
                ytId={tutorial.ytId}
                ytSi={tutorial.ytSi}
                show={showTutorial}
                onClose={() => setShowTutorial(false)}
                onConcluir={concluir}
                concluido={visualizado}
            />
            <Botao
                variant='tutorial'
                onClick={() => setShowTutorial(true)}
                icon={mdiSchool}
                iconProps={{ size: 1.5, style: { backgroundColor: 'var(--tc-color-tutorial-400)', padding: '4px', borderRadius: '20px' } }}
                style={{ fontSize: '1.2rem', marginTop: '1rem', height: '52px' }}
            >
                Ver tutorial
            </Botao>
        </>
    )
}
